import { Injectable } from '@angular/core';

@Injectable()
export class StyleService {
  public readonly secondaryColor = 'var(--secondary-color)';
  public readonly thirdColor = 'var(--third-color)';
  public readonly buttonTextColor = 'var(--primary-dark-color)';
  constructor() {}

  public setGridToolbarButtonColor = (id: string, toolbarButtonIds: string[]): void => {
    const selectedFilterButton = document.getElementById(id).style;
    selectedFilterButton.backgroundColor = this.secondaryColor;
    selectedFilterButton.color = this.thirdColor;
    if (toolbarButtonIds.length > 0) {
      toolbarButtonIds.forEach((_id) => {
        if (_id !== id) {
          const otherFilterButton = document.getElementById(_id).style;
          otherFilterButton.backgroundColor = this.thirdColor;
          otherFilterButton.color = this.buttonTextColor;
        }
      });
    }
  };
}
